import { Injectable } from '@angular/core';

@Injectable()
export class GridUtilities {



    static numberComparator(num1, num2, node1, node2) {

        if (num1 === null && num2 === null) {
            return 0;
        }
        if (num1 === null) {
            return -1;
        }
        if (num2 === null) {
            return 1;
        }

        var num1Number = parseFloat(num1.replace(/[^\/\d]/g, ''));
        var num2Number = parseFloat(num2.replace(/[^\/\d]/g, ''));

        if (num1Number === null && num2Number === null) {
            return 0;
        }
        if (num1Number === null) {
            return -1;
        }
        if (num2Number === null) {
            return 1;
        }
        return num1Number - num2Number;
    }

    static dateComparator(num1, num2, node1, node2) {

        if (num1 === null && num2 === null) {
            return 0;
        }
        if (num1 === null) {
            return -1;
        }
        if (num2 === null) {
            return 1;
        }

        var num1Number = num1.value;
        var num2Number = num2.value;

        if (num1Number === null && num2Number === null) {
            return 0;
        }
        if (num1Number === null) {
            return -1;
        }
        if (num2Number === null) {
            return 1;
        }

        return num1Number - num2Number;
    }

    static dateRenderer(params) {
        if (params.value) {
            return params.value.display;
        }
        return '';
    }

    static currencyRenderer(params){
        if (params.value) {
            return params.value.toLocaleString();
        }else{
            return '';
        }
        
    }

    static  updateObject(obj, key, val, replacement) {
        var objects = [];
        for (var i in obj) {
            if (!obj.hasOwnProperty(i)) continue;
            if (typeof obj[i] == 'object') {
                objects = objects.concat(this.updateObject(obj[i], key, val, replacement));
            } else
                //if key matches and value matches or if key matches and value is not passed (eliminating the case where key matches but passed value does not)
                if (i == key && obj[i] == val || i == key && val == '') { //

                    for (var j in replacement) {
                        obj[j] = replacement[j];
                    }
                    //Found the matches
                    // obj.templateOptions.label = "New First Name 2";
                    // objects.push(obj);
                }
        }
        // return objects;
    }
}





// WEBPACK FOOTER //
// ./src/app/shared/components/grid/GridUtilities.ts